import folderDownload from "@iconify/icons-mdi/folder-download";
import folderMultiple from '@iconify/icons-mdi/folder-multiple';
import folderAccount from '@iconify/icons-mdi/folder-account';
import folderClock from '@iconify/icons-mdi/folder-clock';
import folderStar from '@iconify/icons-mdi/folder-star';
import appsIcon from '@iconify/icons-mdi/apps';
import { Icon } from "@iconify/react";
import React from "react";
import * as Constants from "../../../data/StringConstants";

const foldersIconProps = {
    width: "1.75em",
    height: "1.75em"
}


export default
    [
        {
            sectionTitle: "Items",
            sectionItems: [
                {
                    title: Constants.HEADER_TEXT_ALL_ITEMS,
                    ariaLabel: Constants.HEADER_DESCRIPTION_ALL_ITEMS,
                    url: Constants.ROUTE_URIS.FOLDERS_ALL_ITEMS,
                    icon: <Icon icon={appsIcon} {...foldersIconProps}/>
                },
            ]
        },
        {
            sectionTitle: "Folders",
            sectionItems: [
                {
                    title: Constants.HEADER_TEXT_ALL_FOLDERS,
                    ariaLabel: Constants.HEADER_DESCRIPTION_ALL_FOLDERS,
                    url: Constants.ROUTE_URIS.FOLDERS_ALL_FOLDERS,
                    icon: <Icon icon={folderMultiple} {...foldersIconProps}/>
                },
                {
                    title: Constants.HEADER_TEXT_MY_FOLDERS,
                    ariaLabel: Constants.HEADER_DESCRIPTION_MY_FOLDERS,
                    url: Constants.ROUTE_URIS.FOLDERS_MY_FOLDERS,
                    icon: <Icon icon={folderAccount} {...foldersIconProps}/>
                },
                {
                    title: Constants.HEADER_TEXT_RECENTLY_UPDATED_FOLDERS,
                    ariaLabel:
                        Constants.HEADER_DESCRIPTION_RECENTLY_UPDATED_FOLDERS,
                    url: Constants.ROUTE_URIS.FOLDERS_RECENTLY_UPDATED_FOLDERS,
                    icon: <Icon icon={folderClock} {...foldersIconProps}/>
                },
                {
                    title: Constants.HEADER_TEXT_STARRED_FOLDERS,
                    ariaLabel: Constants.HEADER_DESCRIPTION_STARRED_FOLDERS,
                    url: Constants.ROUTE_URIS.FOLDERS_STARRED_FOLDERS,
                    icon: <Icon icon={folderStar} {...foldersIconProps}/>
                },
                {
                    title: Constants.HEADER_TEXT_ARCHIVED_FOLDERS,
                    ariaLabel: Constants.HEADER_DESCRIPTION_ARCHIVED_FOLDERS,
                    url: Constants.ROUTE_URIS.FOLDERS_ARCHIVED_FOLDERS,
                    icon: <Icon icon={folderDownload} {...foldersIconProps}/>
                }
            ]
        }
    ];
